// @flow
// @flow-runtime warn
import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import prop from 'ramda/es/prop';
import clone from 'ramda/es/clone';

import { getDomain } from 'app/common/lib/params';
import Loading from 'app/common/components/Loader';
import api from 'app/actions/api';
import action from 'app/common/lib/action';
import isProduction from 'app/common/lib/isProduction';


type RequestResult = {
  result: 'success',
  code: string,
}

type Props = {
  onSuccess?: () => void,
}

const YaKlassRedirect = ({ onSuccess }: Props) => {
  const { t } = useTranslation('app');
  const dispatch = useDispatch();

  const requestCodeAndRedirect = useCallback(async () => {
    const requestPath = 'account/disposable_code';
    try {
      const res = await api(requestPath, 'get');
      const data: RequestResult = prop('data', res);
      const code = prop('code', data) || '';
      if (!code) {
        dispatch(action('REQUEST_FAILURE', {
          err: t('request_disposable_code_failed'),
          path: requestPath,
          error: {
            response: {},
          },
        }));
        return;
      }
      const currentParams = window.location.search;
      const newParams = currentParams ? `${currentParams}&code=${code}` : `?code=${code}`;
      const openInNewWindow = !currentParams;
      const openUrl = (
        isProduction()
          ? `https://dealer.${getDomain()}/services/oauth/processing/yaklass${newParams}`
          : `https://sys0.sms-dnevnik.com/services/oauth/processing/yaklass${newParams}`
      );

      console.log(`opening Url in ${openInNewWindow ? 'new window' : 'same window'}: `, openUrl);

      if (openInNewWindow) {
        const newWindow = window.open(openUrl, '_blank');
        if (!newWindow) {
          // окно заблокировано, открываем в том же окне
          window.location = openUrl;
          return;
        }
        if (onSuccess) {
          onSuccess();
        }
      } else {
        window.location = openUrl;
      }
    } catch (error) {
      const errorSave = {
        err: t('request_disposable_code_failed'),
        path: requestPath,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
    }
  }, [onSuccess, dispatch, t]);

  useEffect(() => {
    requestCodeAndRedirect();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Loading />
  );
};

export default YaKlassRedirect;
